/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { withoutUndefinedValues } from "@pagopa/ts-commons/lib/types";
import {
  RequestParams,
  TypeofApiCall,
  TypeofApiParams,
  createFetchRequestForApi,
  ReplaceRequestParams
} from "@pagopa/ts-commons/lib/requests";
import { identity } from "fp-ts/lib/function";

import {
  DeleteMockResource_1T,
  deleteMockResource_1DefaultDecoder,
  GetArchetypesT,
  getArchetypesDefaultDecoder,
  CreateArchetypeT,
  createArchetypeDefaultDecoder,
  ImportArchetypesFromOpenAPIT,
  importArchetypesFromOpenAPIDefaultDecoder,
  GetArchetypeT,
  getArchetypeDefaultDecoder,
  UpdateArchetypeT,
  updateArchetypeDefaultDecoder,
  CreateMockResourceFromArchetypeT,
  createMockResourceFromArchetypeDefaultDecoder,
  HealthCheckT,
  healthCheckDefaultDecoder,
  GetMockResourcesT,
  getMockResourcesDefaultDecoder,
  CreateMockResourceT,
  createMockResourceDefaultDecoder,
  DeleteMockResourceT,
  deleteMockResourceDefaultDecoder,
  GetMockResourceT,
  getMockResourceDefaultDecoder,
  UpdateMockResourceT,
  updateMockResourceDefaultDecoder,
  UpdateMockResourceGeneralInfoT,
  updateMockResourceGeneralInfoDefaultDecoder,
  CreateMockRuleT,
  createMockRuleDefaultDecoder,
  UpdateMockRuleT,
  updateMockRuleDefaultDecoder,
  GetScriptsT,
  getScriptsDefaultDecoder
} from "./requestTypes";

// This is a placeholder for undefined when dealing with object keys
// Typescript doesn't perform well when narrowing a union type which includes string and undefined
// (example: "foo" | "bar" | undefined)
// We use this as a placeholder for type parameters indicating "no key"
type __UNDEFINED_KEY = "_____";

export type ApiOperation = TypeofApiCall<DeleteMockResource_1T> &
  TypeofApiCall<GetArchetypesT> &
  TypeofApiCall<CreateArchetypeT> &
  TypeofApiCall<ImportArchetypesFromOpenAPIT> &
  TypeofApiCall<GetArchetypeT> &
  TypeofApiCall<UpdateArchetypeT> &
  TypeofApiCall<CreateMockResourceFromArchetypeT> &
  TypeofApiCall<HealthCheckT> &
  TypeofApiCall<GetMockResourcesT> &
  TypeofApiCall<CreateMockResourceT> &
  TypeofApiCall<DeleteMockResourceT> &
  TypeofApiCall<GetMockResourceT> &
  TypeofApiCall<UpdateMockResourceT> &
  TypeofApiCall<UpdateMockResourceGeneralInfoT> &
  TypeofApiCall<CreateMockRuleT> &
  TypeofApiCall<UpdateMockRuleT> &
  TypeofApiCall<GetScriptsT>;

export type ParamKeys = keyof (TypeofApiParams<DeleteMockResource_1T> &
  TypeofApiParams<GetArchetypesT> &
  TypeofApiParams<CreateArchetypeT> &
  TypeofApiParams<ImportArchetypesFromOpenAPIT> &
  TypeofApiParams<GetArchetypeT> &
  TypeofApiParams<UpdateArchetypeT> &
  TypeofApiParams<CreateMockResourceFromArchetypeT> &
  TypeofApiParams<HealthCheckT> &
  TypeofApiParams<GetMockResourcesT> &
  TypeofApiParams<CreateMockResourceT> &
  TypeofApiParams<DeleteMockResourceT> &
  TypeofApiParams<GetMockResourceT> &
  TypeofApiParams<UpdateMockResourceT> &
  TypeofApiParams<UpdateMockResourceGeneralInfoT> &
  TypeofApiParams<CreateMockRuleT> &
  TypeofApiParams<UpdateMockRuleT> &
  TypeofApiParams<GetScriptsT>);

/**
 * Defines an adapter for TypeofApiCall which omit one or more parameters in the signature
 * @param ApiT the type which defines the operation to expose
 * @param K the parameter to omit. undefined means no parameters will be omitted
 */
export type OmitApiCallParams<
  ApiT,
  K extends ParamKeys | __UNDEFINED_KEY = __UNDEFINED_KEY
> = (
  op: TypeofApiCall<ApiT>
) => K extends __UNDEFINED_KEY
  ? TypeofApiCall<ApiT>
  : TypeofApiCall<ReplaceRequestParams<ApiT, Omit<RequestParams<ApiT>, K>>>;

/**
 * Defines an adapter for TypeofApiCall which omit one or more parameters in the signature
 * @param ApiT the type which defines the operation to expose
 * @param K the parameter to omit. undefined means no parameters will be omitted
 */
export type WithDefaultsT<
  K extends ParamKeys | __UNDEFINED_KEY = __UNDEFINED_KEY
> = OmitApiCallParams<
  | DeleteMockResource_1T
  | GetArchetypesT
  | CreateArchetypeT
  | ImportArchetypesFromOpenAPIT
  | GetArchetypeT
  | UpdateArchetypeT
  | CreateMockResourceFromArchetypeT
  | HealthCheckT
  | GetMockResourcesT
  | CreateMockResourceT
  | DeleteMockResourceT
  | GetMockResourceT
  | UpdateMockResourceT
  | UpdateMockResourceGeneralInfoT
  | CreateMockRuleT
  | UpdateMockRuleT
  | GetScriptsT,
  K
>;

/**
 * Defines a collection of api operations
 * @param K name of the parameters that the Clients masks from the operations
 */
export type Client<
  K extends ParamKeys | __UNDEFINED_KEY = __UNDEFINED_KEY
> = K extends __UNDEFINED_KEY
  ? {
      readonly deleteMockResource_1: TypeofApiCall<DeleteMockResource_1T>;

      readonly getArchetypes: TypeofApiCall<GetArchetypesT>;

      readonly createArchetype: TypeofApiCall<CreateArchetypeT>;

      readonly importArchetypesFromOpenAPI: TypeofApiCall<
        ImportArchetypesFromOpenAPIT
      >;

      readonly getArchetype: TypeofApiCall<GetArchetypeT>;

      readonly updateArchetype: TypeofApiCall<UpdateArchetypeT>;

      readonly createMockResourceFromArchetype: TypeofApiCall<
        CreateMockResourceFromArchetypeT
      >;

      readonly healthCheck: TypeofApiCall<HealthCheckT>;

      readonly getMockResources: TypeofApiCall<GetMockResourcesT>;

      readonly createMockResource: TypeofApiCall<CreateMockResourceT>;

      readonly deleteMockResource: TypeofApiCall<DeleteMockResourceT>;

      readonly getMockResource: TypeofApiCall<GetMockResourceT>;

      readonly updateMockResource: TypeofApiCall<UpdateMockResourceT>;

      readonly updateMockResourceGeneralInfo: TypeofApiCall<
        UpdateMockResourceGeneralInfoT
      >;

      readonly createMockRule: TypeofApiCall<CreateMockRuleT>;

      readonly updateMockRule: TypeofApiCall<UpdateMockRuleT>;

      readonly getScripts: TypeofApiCall<GetScriptsT>;
    }
  : {
      readonly deleteMockResource_1: TypeofApiCall<
        ReplaceRequestParams<
          DeleteMockResource_1T,
          Omit<RequestParams<DeleteMockResource_1T>, K>
        >
      >;

      readonly getArchetypes: TypeofApiCall<
        ReplaceRequestParams<
          GetArchetypesT,
          Omit<RequestParams<GetArchetypesT>, K>
        >
      >;

      readonly createArchetype: TypeofApiCall<
        ReplaceRequestParams<
          CreateArchetypeT,
          Omit<RequestParams<CreateArchetypeT>, K>
        >
      >;

      readonly importArchetypesFromOpenAPI: TypeofApiCall<
        ReplaceRequestParams<
          ImportArchetypesFromOpenAPIT,
          Omit<RequestParams<ImportArchetypesFromOpenAPIT>, K>
        >
      >;

      readonly getArchetype: TypeofApiCall<
        ReplaceRequestParams<
          GetArchetypeT,
          Omit<RequestParams<GetArchetypeT>, K>
        >
      >;

      readonly updateArchetype: TypeofApiCall<
        ReplaceRequestParams<
          UpdateArchetypeT,
          Omit<RequestParams<UpdateArchetypeT>, K>
        >
      >;

      readonly createMockResourceFromArchetype: TypeofApiCall<
        ReplaceRequestParams<
          CreateMockResourceFromArchetypeT,
          Omit<RequestParams<CreateMockResourceFromArchetypeT>, K>
        >
      >;

      readonly healthCheck: TypeofApiCall<
        ReplaceRequestParams<HealthCheckT, Omit<RequestParams<HealthCheckT>, K>>
      >;

      readonly getMockResources: TypeofApiCall<
        ReplaceRequestParams<
          GetMockResourcesT,
          Omit<RequestParams<GetMockResourcesT>, K>
        >
      >;

      readonly createMockResource: TypeofApiCall<
        ReplaceRequestParams<
          CreateMockResourceT,
          Omit<RequestParams<CreateMockResourceT>, K>
        >
      >;

      readonly deleteMockResource: TypeofApiCall<
        ReplaceRequestParams<
          DeleteMockResourceT,
          Omit<RequestParams<DeleteMockResourceT>, K>
        >
      >;

      readonly getMockResource: TypeofApiCall<
        ReplaceRequestParams<
          GetMockResourceT,
          Omit<RequestParams<GetMockResourceT>, K>
        >
      >;

      readonly updateMockResource: TypeofApiCall<
        ReplaceRequestParams<
          UpdateMockResourceT,
          Omit<RequestParams<UpdateMockResourceT>, K>
        >
      >;

      readonly updateMockResourceGeneralInfo: TypeofApiCall<
        ReplaceRequestParams<
          UpdateMockResourceGeneralInfoT,
          Omit<RequestParams<UpdateMockResourceGeneralInfoT>, K>
        >
      >;

      readonly createMockRule: TypeofApiCall<
        ReplaceRequestParams<
          CreateMockRuleT,
          Omit<RequestParams<CreateMockRuleT>, K>
        >
      >;

      readonly updateMockRule: TypeofApiCall<
        ReplaceRequestParams<
          UpdateMockRuleT,
          Omit<RequestParams<UpdateMockRuleT>, K>
        >
      >;

      readonly getScripts: TypeofApiCall<
        ReplaceRequestParams<GetScriptsT, Omit<RequestParams<GetScriptsT>, K>>
      >;
    };

/**
 * Create an instance of a client
 * @param params hash map of parameters thata define the client:
 *  - baseUrl: the base url for every api call (required)
 *  - fetchApi: an implementation of the fetch() web API, depending on the platform (required)
 *  - basePath: optional path to be appended to the baseUrl
 *  - withDefaults: optional adapter to be applied to every operation, to omit some paramenters
 * @returns a collection of api operations
 */
export function createClient<K extends ParamKeys>(params: {
  baseUrl: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fetchApi: typeof fetch;
  withDefaults: WithDefaultsT<K>;
  basePath?: string;
}): Client<K>;
export function createClient(params: {
  baseUrl: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fetchApi: typeof fetch;
  withDefaults?: undefined;
  basePath?: string;
}): Client;
export function createClient<K extends ParamKeys>({
  baseUrl,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fetchApi,
  withDefaults,
  basePath = "/"
}: {
  baseUrl: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fetchApi: typeof fetch;
  withDefaults?: WithDefaultsT<K>;
  basePath?: string;
}) {
  const options = {
    baseUrl,
    fetchApi
  };

  const deleteMockResource_1T: ReplaceRequestParams<
    DeleteMockResource_1T,
    RequestParams<DeleteMockResource_1T>
  > = {
    method: "delete",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: deleteMockResource_1DefaultDecoder(),
    url: ({}) => `${basePath}/archetypes`,

    query: ({ ["subsystem"]: subsystem }) =>
      withoutUndefinedValues({ ["subsystem"]: subsystem })
  };
  const deleteMockResource_1: TypeofApiCall<DeleteMockResource_1T> = createFetchRequestForApi(
    deleteMockResource_1T,
    options
  );

  const getArchetypesT: ReplaceRequestParams<
    GetArchetypesT,
    RequestParams<GetArchetypesT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getArchetypesDefaultDecoder(),
    url: ({}) => `${basePath}/archetypes`,

    query: ({ ["limit"]: limit, ["page"]: page }) =>
      withoutUndefinedValues({ ["limit"]: limit, ["page"]: page })
  };
  const getArchetypes: TypeofApiCall<GetArchetypesT> = createFetchRequestForApi(
    getArchetypesT,
    options
  );

  const createArchetypeT: ReplaceRequestParams<
    CreateArchetypeT,
    RequestParams<CreateArchetypeT>
  > = {
    method: "post",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: createArchetypeDefaultDecoder(),
    url: ({}) => `${basePath}/archetypes`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const createArchetype: TypeofApiCall<CreateArchetypeT> = createFetchRequestForApi(
    createArchetypeT,
    options
  );

  const importArchetypesFromOpenAPIT: ReplaceRequestParams<
    ImportArchetypesFromOpenAPIT,
    RequestParams<ImportArchetypesFromOpenAPIT>
  > = {
    method: "post",

    // There is a well-known issue about fetch and Content-Type header when it comes to add multipart/form-data files.
    //  reference: https://github.com/github/fetch/issues/505#issuecomment-293064470
    // The solution is to skip the Content-Type header and let fetch add it for us.
    // @ts-ignore as IRequestType would require something
    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: importArchetypesFromOpenAPIDefaultDecoder(),
    url: ({}) => `${basePath}/archetypes/import`,

    body: ({ ["file"]: file }) => {
      if (typeof window === "undefined")
        throw new Error(
          "File upload is only support inside a browser runtime envoronment"
        );
      const formData = new FormData();
      formData.append("file", file);
      return formData;
    },

    query: ({ ["subsystem"]: subsystem }) =>
      withoutUndefinedValues({ ["subsystem"]: subsystem })
  };
  const importArchetypesFromOpenAPI: TypeofApiCall<ImportArchetypesFromOpenAPIT> = createFetchRequestForApi(
    importArchetypesFromOpenAPIT,
    options
  );

  const getArchetypeT: ReplaceRequestParams<
    GetArchetypeT,
    RequestParams<GetArchetypeT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getArchetypeDefaultDecoder(),
    url: ({ ["archetypeId"]: archetypeId }) =>
      `${basePath}/archetypes/${archetypeId}`,

    query: () => withoutUndefinedValues({})
  };
  const getArchetype: TypeofApiCall<GetArchetypeT> = createFetchRequestForApi(
    getArchetypeT,
    options
  );

  const updateArchetypeT: ReplaceRequestParams<
    UpdateArchetypeT,
    RequestParams<UpdateArchetypeT>
  > = {
    method: "put",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: updateArchetypeDefaultDecoder(),
    url: ({ ["archetypeId"]: archetypeId }) =>
      `${basePath}/archetypes/${archetypeId}`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const updateArchetype: TypeofApiCall<UpdateArchetypeT> = createFetchRequestForApi(
    updateArchetypeT,
    options
  );

  const createMockResourceFromArchetypeT: ReplaceRequestParams<
    CreateMockResourceFromArchetypeT,
    RequestParams<CreateMockResourceFromArchetypeT>
  > = {
    method: "post",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: createMockResourceFromArchetypeDefaultDecoder(),
    url: ({ ["archetypeId"]: archetypeId }) =>
      `${basePath}/archetypes/${archetypeId}/generate`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const createMockResourceFromArchetype: TypeofApiCall<CreateMockResourceFromArchetypeT> = createFetchRequestForApi(
    createMockResourceFromArchetypeT,
    options
  );

  const healthCheckT: ReplaceRequestParams<
    HealthCheckT,
    RequestParams<HealthCheckT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: healthCheckDefaultDecoder(),
    url: ({}) => `${basePath}/info`,

    query: () => withoutUndefinedValues({})
  };
  const healthCheck: TypeofApiCall<HealthCheckT> = createFetchRequestForApi(
    healthCheckT,
    options
  );

  const getMockResourcesT: ReplaceRequestParams<
    GetMockResourcesT,
    RequestParams<GetMockResourcesT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getMockResourcesDefaultDecoder(),
    url: ({}) => `${basePath}/resources`,

    query: ({
      ["limit"]: limit,
      ["page"]: page,
      ["name"]: name,
      ["tag"]: tag
    }) =>
      withoutUndefinedValues({
        ["limit"]: limit,
        ["page"]: page,
        ["name"]: name,
        ["tag"]: tag
      })
  };
  const getMockResources: TypeofApiCall<GetMockResourcesT> = createFetchRequestForApi(
    getMockResourcesT,
    options
  );

  const createMockResourceT: ReplaceRequestParams<
    CreateMockResourceT,
    RequestParams<CreateMockResourceT>
  > = {
    method: "post",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: createMockResourceDefaultDecoder(),
    url: ({}) => `${basePath}/resources`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const createMockResource: TypeofApiCall<CreateMockResourceT> = createFetchRequestForApi(
    createMockResourceT,
    options
  );

  const deleteMockResourceT: ReplaceRequestParams<
    DeleteMockResourceT,
    RequestParams<DeleteMockResourceT>
  > = {
    method: "delete",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: deleteMockResourceDefaultDecoder(),
    url: ({ ["resourceId"]: resourceId }) =>
      `${basePath}/resources/${resourceId}`,

    query: () => withoutUndefinedValues({})
  };
  const deleteMockResource: TypeofApiCall<DeleteMockResourceT> = createFetchRequestForApi(
    deleteMockResourceT,
    options
  );

  const getMockResourceT: ReplaceRequestParams<
    GetMockResourceT,
    RequestParams<GetMockResourceT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getMockResourceDefaultDecoder(),
    url: ({ ["resourceId"]: resourceId }) =>
      `${basePath}/resources/${resourceId}`,

    query: () => withoutUndefinedValues({})
  };
  const getMockResource: TypeofApiCall<GetMockResourceT> = createFetchRequestForApi(
    getMockResourceT,
    options
  );

  const updateMockResourceT: ReplaceRequestParams<
    UpdateMockResourceT,
    RequestParams<UpdateMockResourceT>
  > = {
    method: "put",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: updateMockResourceDefaultDecoder(),
    url: ({ ["resourceId"]: resourceId }) =>
      `${basePath}/resources/${resourceId}`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const updateMockResource: TypeofApiCall<UpdateMockResourceT> = createFetchRequestForApi(
    updateMockResourceT,
    options
  );

  const updateMockResourceGeneralInfoT: ReplaceRequestParams<
    UpdateMockResourceGeneralInfoT,
    RequestParams<UpdateMockResourceGeneralInfoT>
  > = {
    method: "put",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: updateMockResourceGeneralInfoDefaultDecoder(),
    url: ({ ["resourceId"]: resourceId }) =>
      `${basePath}/resources/${resourceId}/general-info`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const updateMockResourceGeneralInfo: TypeofApiCall<UpdateMockResourceGeneralInfoT> = createFetchRequestForApi(
    updateMockResourceGeneralInfoT,
    options
  );

  const createMockRuleT: ReplaceRequestParams<
    CreateMockRuleT,
    RequestParams<CreateMockRuleT>
  > = {
    method: "post",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: createMockRuleDefaultDecoder(),
    url: ({ ["resourceId"]: resourceId }) =>
      `${basePath}/resources/${resourceId}/rules`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const createMockRule: TypeofApiCall<CreateMockRuleT> = createFetchRequestForApi(
    createMockRuleT,
    options
  );

  const updateMockRuleT: ReplaceRequestParams<
    UpdateMockRuleT,
    RequestParams<UpdateMockRuleT>
  > = {
    method: "put",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: updateMockRuleDefaultDecoder(),
    url: ({ ["resourceId"]: resourceId, ["ruleId"]: ruleId }) =>
      `${basePath}/resources/${resourceId}/rules/${ruleId}`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const updateMockRule: TypeofApiCall<UpdateMockRuleT> = createFetchRequestForApi(
    updateMockRuleT,
    options
  );

  const getScriptsT: ReplaceRequestParams<
    GetScriptsT,
    RequestParams<GetScriptsT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getScriptsDefaultDecoder(),
    url: ({}) => `${basePath}/scripting`,

    query: ({ ["name"]: name }) => withoutUndefinedValues({ ["name"]: name })
  };
  const getScripts: TypeofApiCall<GetScriptsT> = createFetchRequestForApi(
    getScriptsT,
    options
  );

  return {
    deleteMockResource_1: (withDefaults || identity)(deleteMockResource_1),
    getArchetypes: (withDefaults || identity)(getArchetypes),
    createArchetype: (withDefaults || identity)(createArchetype),
    importArchetypesFromOpenAPI: (withDefaults || identity)(
      importArchetypesFromOpenAPI
    ),
    getArchetype: (withDefaults || identity)(getArchetype),
    updateArchetype: (withDefaults || identity)(updateArchetype),
    createMockResourceFromArchetype: (withDefaults || identity)(
      createMockResourceFromArchetype
    ),
    healthCheck: (withDefaults || identity)(healthCheck),
    getMockResources: (withDefaults || identity)(getMockResources),
    createMockResource: (withDefaults || identity)(createMockResource),
    deleteMockResource: (withDefaults || identity)(deleteMockResource),
    getMockResource: (withDefaults || identity)(getMockResource),
    updateMockResource: (withDefaults || identity)(updateMockResource),
    updateMockResourceGeneralInfo: (withDefaults || identity)(
      updateMockResourceGeneralInfo
    ),
    createMockRule: (withDefaults || identity)(createMockRule),
    updateMockRule: (withDefaults || identity)(updateMockRule),
    getScripts: (withDefaults || identity)(getScripts)
  };
}
